import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found", description: "The page you were looking for could not be found.", robots: "noindex,nofollow" });
  return (
    <div className="container-ab py-24 text-center lg:py-32" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-serif text-5xl font-semibold tracking-tight sm:text-6xl">This page has gone missing.</h1>
      <p className="mx-auto mt-5 max-w-md text-lg text-ab-text-2">Perhaps it was moved, or the link had a typo. The homepage and search are good places to pick up again.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-primary" data-testid="not-found-home-link">Back to homepage</Link>
        <Link to="/search/" className="btn-secondary" data-testid="not-found-search-link">Search articles</Link>
      </div>
    </div>
  );
}
